module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " til ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " valgt");
  },
  "finishRangeSelectionPrompt": "Klikk for \xE5 fullf\xF8re valg av datoomr\xE5de",
  "maximumDate": "Siste tilgjengelige dato",
  "minimumDate": "F\xF8rste tilgjengelige dato",
  "next": "Neste",
  "previous": "Forrige",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valgt dato: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valgt omr\xE5de: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Klikk for \xE5 starte valg av datoomr\xE5de",
  "todayDate": function todayDate(args) {
    return "I dag, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "I dag, ".concat(args.date, " valgt");
  }
};